module.exports = __webpack_public_path__ + "static/media/back.56b9c0dd.svg";